import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=8328ce3a&scoped=true"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"
import style0 from "./Call.vue?vue&type=style&index=0&id=8328ce3a&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8328ce3a",
  null
  
)

export default component.exports